module.exports = __webpack_public_path__ + "img/internet-explorer.e2cd9de0.gif";